import { types } from 'mobx-state-tree'
import { PrintedcircuitboardProperties } from 'src/api/models/Content/Printedcircuitboard/PrintedcircuitboardProperties'
import {
  getPrintedcircuitboardBoundings,
  getPrintedcircuitboardPlateBoundings
} from 'src/api/models/utils'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { printedcircuitboard } from 'src/constants/typenames'
import { getReferencePoints } from 'src/utils/getReferencePoints'
import { Side } from 'src/constants/sides'
import { ReferencePoint, ReferencePoints } from 'src/constants/referencePoints'
import { printedcircuitboard as printedcircuitboardLayer } from 'src/constants/layers'
import { IPrintedcircuitboard } from './types'

export const Printedcircuitboard = (): IPrintedcircuitboard =>
  generateNodeType(printedcircuitboard)
    .props({ properties: types.late(PrintedcircuitboardProperties) })
    .views(self => ({
      get boundings() {
        const boundings = getPrintedcircuitboardBoundings(self)
        return boundings
      },
      getReferencePoints(side: Side) {
        const boundings = getPrintedcircuitboardPlateBoundings(self.properties)
        return getReferencePoints(boundings)[side]
      }
    }))
    .views(self => ({
      get referencePoints(): ReferencePoints<[number, number, number]> | null {
        return self.focusedSide && self.getReferencePoints(self.focusedSide)
      },
      get layers() {
        return printedcircuitboardLayer
      }
    }))
